// Third Party Imports
import React from 'react';

// Relative Imports
import DialogBox from '../DialogBox';
import AlertBox from '../Alert/Alert';
import introductionImage1 from '../../images/intro_img1.svg';
import introductionImage2 from '../../images/intro_img2.svg';
import backgroundImage from '../../images/cabin-blue-create-account-page.svg';
import './Introduction.less';
import { getIntroductionContents } from '../utils/introductionPageUtil';
import { ButtonPrimary } from '@homeaway/react-buttons';

export default class Introduction extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    getOldIntroContent() {
        const { userType, translations, serviceError, firstName, handleSubmit, handleAlertDismiss, siteName, disableContinueButton, isSWSv2FlowEnabled } = this.props;
        const introductionContents = getIntroductionContents(userType, translations, firstName, siteName, isSWSv2FlowEnabled);

        return (
            <div id="introduction" className="introduction-pg">
                {
                    serviceError
                        ? <div className="alert-container">
                            <div className="alert-wrapper">
                                <div className="alert-panel">
                                    <AlertBox
                                        messageKey={serviceError}
                                        translations={translations}
                                        handleAlertDismiss={handleAlertDismiss}
                                    />
                                </div>
                            </div>
                        </div>
                        : null
                }
                <div className="intro-page-wrapper">
                    <div className="overlay" />
                    <img className="intro-pg-img intro-pg-img-1" src={introductionImage1()} />
                    <img className="intro-pg-img intro-pg-img-2" src={introductionImage2()} />
                    <DialogBox
                        handleSubmit={handleSubmit}
                        styles={introductionContents.styles}
                        actionLabel={translations['ipmob.continue']}
                        contents={introductionContents.contents}
                        dialogHeading={introductionContents.dialogHeading}
                        heading={introductionContents.heading}
                        headingDesc={introductionContents.headingDesc}
                        dialogFooter={translations['ipmob.introduction.description_5']}
                        userType={userType}
                        isButtonDisabled={disableContinueButton}
                    />
                </div>
                <div className="trim-bg-image" />
            </div>
        );
    }

    getNewIntroContent() {
        const { translations, serviceError, handleAlertDismiss, handleSubmit } = this.props;
        return (
            <div id="introduction" className="introduction-pg">
                {
                    serviceError
                        ? <div className="alert-container">
                            <div className="alert-wrapper">
                                <div className="alert-panel">
                                    <AlertBox
                                        messageKey={serviceError}
                                        translations={translations}
                                        handleAlertDismiss={handleAlertDismiss}
                                    />
                                </div>
                            </div>
                        </div>
                        : null
                }
                <div className="intro-pg-mor-wrapper">
                    <div className="overlay" />
                    <div>
                        <h1>{translations['ipmob.mor.introduction.heading']}</h1>
                        <p>{translations['ipmob.mor.introduction.description_1']}</p>
                        <p>{translations['ipmob.mor.introduction.description_2']}</p>
                        <ul>
                            <li>{translations['ipmob.mor.introduction.bullet_1']}</li>
                            <li>{translations['ipmob.mor.introduction.bullet_2']}</li>
                            <li>{translations['ipmob.mor.introduction.bullet_3']}</li>
                            <li>{translations['ipmob.mor.introduction.bullet_4']}</li>
                        </ul>
                        <p>{translations['ipmob.mor.introduction.description_3']}</p>
                        <ButtonPrimary
                            label={translations['ipmob.continue']}
                            type="submit"
                            value="Continue"
                            id={'ContinueButton'}
                            onClick={handleSubmit}
                        />
                    </div>
                </div>
                <img className="intro-pg-bg-img" src={backgroundImage()} />
            </div>
        );
    }

    render() {
        const { showNewIntroContent } = this.props;
        if (showNewIntroContent) {
            return this.getNewIntroContent();
        }
        return this.getOldIntroContent();
    }
}
